import { render, staticRenderFns } from "./CreateOrderArticles.vue?vue&type=template&id=94976df8"
import script from "./CreateOrderArticles.vue?vue&type=script&lang=js"
export * from "./CreateOrderArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports